import { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'

import { MediaGQLFields } from '../../global-types/fields.global.generated.js'

import { CustomCodeFields } from './customCode.fields.js'
import { NetworkFields, networkGQLFields } from './network.fields.js'
import { TopNavigationFields } from './topNavigation.fields.js'

// eslint-disable-next-line unused-imports/no-unused-vars
export function customCodeGQLFields(fields: CustomCodeFields): string {
  return `
    anonymize
    position
    code
    isCmpProvider
  `
}

// eslint-disable-next-line unused-imports/no-unused-vars
export function topNavigationGQLFields(fields: TopNavigationFields): string {
  return `
    enabled
    items {
      link
      openInNewWindow
      text
      type
    }
  `
}

export function getNetworkGQLQuery(fields: NetworkFields): DocumentNode {
  return gql`
    query Network {
      network {
        ${networkGQLFields(fields)}
      }
    }
  `
}

export function updateNetworkGQLQuery(fields: NetworkFields): DocumentNode {
  return gql`
    mutation updateNetwork($input: UpdateNetworkInput!) {
      updateNetwork(input: $input) {
        ${networkGQLFields(fields)}
      }
    }
  `
}

export const getNetworkContentModulesGQLQuery = () => gql`
  query GetContentModules {
    network {
      contentModules {
        contentModuleType
        authMemberProps {
          contentModuleType
          context
          scopes
          availableSpaces {
            id
            name
            image {
              ${MediaGQLFields({ onImage: { urls: 'all' }, onEmoji: 'all', onGlyph: 'all', onFile: 'all' })}
            }
          }
        }
      }
    }
  }
`
